import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/(main)/dashboard/page.tsx")